// jshint esversion: 8
const getProp = (state, prop) => state[prop]

export default {
  id: state => getProp(state, 'id'),
  username: state => getProp(state, 'username'),
  email: state => getProp(state, 'email'),
  firstName: state => getProp(state, 'first_name'),
  lastName: state => getProp(state, 'last_name'),
  image: state => getProp(state, 'image'),
  department: state => getProp(state, 'department'),
  location: state => getProp(state, 'location')
}
